import React from 'react';
import { Card, Table, Badge } from 'antd';
import { RiseOutlined } from '@ant-design/icons';

const RecentActivities = () => {
  const recentActivities = [
    {
      key: '1',
      user: 'Traiteur Gourmet Plus',
      action: 'Nouveau prestataire inscrit',
      time: 'Il y a 2h',
      status: 'success',
    },
    {
      key: '2',
      user: 'Tech Events Corp',
      action: 'Nouvel événement créé',
      time: 'Il y a 3h',
      status: 'warning',
    },
    {
      key: '3',
      user: 'Digital Solutions',
      action: 'Nouveau sponsor Gold',
      time: 'Il y a 5h',
      status: 'success',
    },
  ];

  const columns = [
    {
      title: 'Utilisateur',
      dataIndex: 'user',
      key: 'user',
      render: (text) => <span className="font-medium text-neutral-800">{text}</span>,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
    },
    {
      title: 'Temps',
      dataIndex: 'time',
      key: 'time',
      render: (text) => <span className="text-neutral-500">{text}</span>,
    },
    {
      title: 'Statut',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Badge 
          status={status} 
          text={status === 'success' ? 'Complété' : status === 'warning' ? 'En cours' : 'Erreur'}
          className={`text-${status}-500`}
        />
      ),
    },
  ];

  return (
    <Card
      title={
        <div className="flex items-center gap-2">
          <RiseOutlined className="text-primary-500" />
          <span className="font-heading">Activités récentes</span>
        </div>
      }
      className="h-full"
    >
      <Table 
        dataSource={recentActivities}
        columns={columns}
        pagination={false}
        className="custom-table"
      />
    </Card>
  );
};

export default RecentActivities;
